import React, { useEffect, useState } from "react";

export default function StudentEMI({ finalFee }) {
  const [emiEnabled, setEmiEnabled] = useState(false);
  const [emiCount, setEmiCount] = useState(1);
  const [emiData, setEmiData] = useState([]);

  useEffect(() => {
    if (emiEnabled && emiCount > 0 && Number(finalFee) > 0) {
      generateEmiData(emiCount);
    }
  }, [finalFee]);

  const generateEmiData = (count) => {
    const totalFee = Number(finalFee || 0);

    if (!totalFee || count < 1) return;

    const perEmi = Math.floor(totalFee / count);

    let arr = [];

    for (let i = 0; i < count; i++) {
      const date = new Date();

      date.setMonth(date.getMonth() + i);

      arr.push({
        date: date.toISOString().split("T")[0],
        amount: i === count - 1 ? totalFee - perEmi * (count - 1) : perEmi,
      });
    }

    setEmiData(arr);
  };

  return (
    <>
      {/* EMI Details */}
      <div className="col-12 mt-4">
        <h6 className="text-primary mt-0 mb-2">EMI Details</h6>

        <div className="row g-3">
          {/* EMI Option */}
          <div className="col-lg-3 col-md-4 col-sm-6">
            <div className="form-floating form-floating-outline">
              <select
                className="form-select"
                value={emiEnabled ? "yes" : "no"}
                onChange={(e) => {
                  const value = e.target.value === "yes";

                  setEmiEnabled(value);

                  if (!value) {
                    setEmiData([]);
                    setEmiCount(1);
                  } else {
                    generateEmiData(emiCount || 1);
                  }
                }}
              >
                <option value="no">No</option>

                <option value="yes">Yes</option>
              </select>

              <label>EMI Status</label>
            </div>
          </div>

          {/* EMI Count */}
          {emiEnabled && (
            <div className="col-lg-3 col-md-4 col-sm-6">
              <div className="form-floating form-floating-outline">
                <input
                  type="number"
                  min={1}
                  className="form-control"
                  value={emiCount}
                  onChange={(e) => {
                    const count = Number(e.target.value);

                    setEmiCount(count);

                    generateEmiData(count);
                  }}
                />

                <label>Total EMI</label>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* EMI Schedule */}
      {emiEnabled && emiData?.length > 0 && (
        <div className="col-12 mt-2">
          <div
            className="border rounded-4 p-3"
            style={{
              background: "#fcfcff",
              borderColor: "#ebe9f1",
            }}
          >
            {/* Header */}
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h6 className="text-primary mb-0 fw-bold">EMI Schedule</h6>

              <div
                className="px-3 py-1"
                style={{
                  background: "#f3f0ff",
                  borderRadius: "10px",
                  fontSize: "13px",
                  fontWeight: "600",
                }}
              >
                Total : ₹
                {emiData.reduce(
                  (sum, item) => sum + Number(item.amount || 0),
                  0
                )}
              </div>
            </div>

            {/* EMI Cards */}
            <div className="row g-2">
              {emiData.map((emi, index) => (
                <div className="col-lg-3 col-md-4 col-sm-6" key={index}>
                  <div
                    className="border rounded-3 p-2"
                    style={{
                      background: "#fff",
                      borderColor: "#ececec",
                    }}
                  >
                    {/* Top */}
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <small className="fw-bold">EMI {index + 1}</small>

                      <small className="text-success fw-bold">
                        ₹{emi.amount}
                      </small>
                    </div>

                    {/* Date */}
                    <input
                      type="date"
                      className="form-control form-control-sm mb-2"
                      name="emi_dates[]"
                      value={emi.date}
                      onChange={(e) => {
                        const updated = [...emiData];

                        updated[index].date = e.target.value;

                        setEmiData(updated);
                      }}
                      style={{
                        borderRadius: "10px",
                        fontSize: "13px",
                      }}
                    />

                    {/* Amount */}
                    <input
                      type="number"
                      className="form-control form-control-sm"
                      name="emi_amounts[]"
                      value={emi.amount}
                      readOnly={index === emiData.length - 1}
                      onChange={(e) => {
                        let value = Number(e.target.value);

                        const updated = [...emiData];

                        const totalFee = Number(finalFee || 0);

                        if (value < 0) value = 0;

                        if (value > totalFee) {
                          value = totalFee;
                        }

                        updated[index].amount = value;

                        const lastIndex = updated.length - 1;

                        if (index === lastIndex) return;

                        const usedAmount = updated
                          .slice(0, index + 1)
                          .reduce(
                            (sum, item) => sum + Number(item.amount || 0),
                            0
                          );

                        let remainingAmount = totalFee - usedAmount;

                        if (remainingAmount < 0) {
                          remainingAmount = 0;
                        }

                        const remainingCount = lastIndex - index;

                        const perEmi = Math.floor(
                          remainingAmount / remainingCount
                        );

                        let extra = remainingAmount - perEmi * remainingCount;

                        for (let i = index + 1; i <= lastIndex; i++) {
                          updated[i].amount = perEmi + (extra > 0 ? 1 : 0);

                          if (extra > 0) extra--;
                        }

                        setEmiData(updated);
                      }}
                      style={{
                        borderRadius: "10px",
                        fontSize: "13px",
                        background:
                          index === emiData.length - 1 ? "#f5f5f5" : "#fff",
                      }}
                    />
                  </div>
                </div>
              ))}
            </div>

            {/* Hidden Input */}
            <input
              type="hidden"
              name="emi_data"
              value={JSON.stringify(emiData)}
            />
            <input
              type="hidden"
              name="emi_status"
              value={emiEnabled ? "yes" : "no"}
            />
          </div>
        </div>
      )}
    </>
  );
}
